var AOPOrderBookPresenter = /** @class */ (function () {
    function AOPOrderBookPresenter(usecase) {
        this.usecase = usecase;
    }
    AOPOrderBookPresenter.prototype.getAopOrderbookVerificationLink = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.aopVerificationLink.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    AOPOrderBookPresenter.prototype.getDownloadAOPOrderbookList = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.aopOrderBookDownload.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    AOPOrderBookPresenter.prototype.getAOPOrderBookClientFilterList = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.aopOrderBookClientFilter.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    AOPOrderBookPresenter.prototype.getApplicationDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.aopOrderBookApplicationDetails.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    AOPOrderBookPresenter.prototype.getAopOrderbookDashboard = function (orderId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.aopOrderBookDashboard.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, orderId);
        });
    };
    AOPOrderBookPresenter.prototype.getAopOrderbookSelfieLink = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.aopOrderBookSelfieLink.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    AOPOrderBookPresenter.prototype.getAopOrderBookESignLink = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.aopOrderBookESignLnk.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    AOPOrderBookPresenter.prototype.getAopOrderBookGetKyc = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.aopOrderBookGetKyc.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    return AOPOrderBookPresenter;
}());
export default AOPOrderBookPresenter;
